class PageAIRevolutionHero {
    constructor(el) {
        this.el = el;
        this.bgVideoDesktop = el.dataset.bgVideoDesktop ? JSON.parse(el.dataset.bgVideoDesktop) : null;
        this.bgVideoTablet = el.dataset.bgVideoTablet ? JSON.parse(el.dataset.bgVideoTablet) : null;
        this.bgVideoPhone = el.dataset.bgVideoPhone ? JSON.parse(el.dataset.bgVideoPhone) : null;
        if(this.bgVideoDesktop && this.bgVideoDesktop.type === "upload" && !this.bgVideoDesktop.file) {
            this.bgVideoDesktop = null;
        }

        if(this.bgVideoTablet && this.bgVideoTablet.type === "upload" && !this.bgVideoTablet.file) {
            this.bgVideoTablet = null;
        }

        if(this.bgVideoPhone && this.bgVideoPhone.type === "upload" && !this.bgVideoPhone.file) {
            this.bgVideoPhone = null;
        }

        this.debounceUpdate = this.debounce(this.update.bind(this), 200);
        this.update();
        window.addEventListener('resize', this.debounceUpdate);
    }

    static init() {
        const el = document.querySelector('.ai-rev-hero');

        if (el) {
            new PageAIRevolutionHero(el);
        }
    }

    update() {
        const screenWidth = window.innerWidth;
        let selectedVideo = null;

        if (screenWidth >= 1024) {
            selectedVideo = this.getVideo(this.bgVideoDesktop);
        } else if (screenWidth >= 768) {
            selectedVideo = this.getVideo(this.bgVideoTablet);
        } else {
            selectedVideo = this.getVideo(this.bgVideoPhone);
        }
        if (selectedVideo) {
            this.setBackgroundVideo(selectedVideo);
        }
    }

    getVideo(video) {
        if (video) {
            if (video.type === 'upload' && video.file) {
                return video;
            } else if (video.type === 'youtube' && video.id) {
                return video;
            }
        }
        return null;
    }

    setBackgroundVideo(video) {
        const videoContainer = this.el.querySelector('.bg-video');
        if (videoContainer) {
            videoContainer.innerHTML = '';

            if (video.type === 'upload') {
                const videoElement = document.createElement('video');
                videoElement.autoplay = true;
                videoElement.loop = true;
                videoElement.muted = true;

                const sourceElement = document.createElement('source');
                sourceElement.src = video.file;
                sourceElement.type = 'video/mp4';

                videoElement.appendChild(sourceElement);
                videoContainer.appendChild(videoElement);

                // Ensure video starts playing immediately
                videoElement.play().catch(error => {
                    console.error("Video play failed: ", error);
                });
            } else if (video.type === 'youtube') {
                const iframeElement = document.createElement('iframe');
                iframeElement.src = `https://www.youtube.com/embed/${video.id}?autoplay=1&loop=1&playlist=${video.id}&controls=0&showinfo=0&rel=0&modestbranding=1&mute=1`;
                iframeElement.frameBorder = '0';
                iframeElement.allow = 'autoplay; encrypted-media';
                iframeElement.allowFullscreen = true;

                videoContainer.appendChild(iframeElement);
            }
        }
    }

    debounce(func, wait) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
}

export default PageAIRevolutionHero;
